export const rollsValueDecimals = 1e5;
export const quantumDrawingTransactionHashStorageKey = "quantum-drawing-game-transaction-hash";
